import React, {useState} from "react";
import t from "../../components/I18N/TranslateHelpers";
import {SearchResult} from "../Entity/SearchResult";
import ProductThumbView from "../Products/ProductView/ProductThumbView";
import {useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";

interface SearchResultProps {
  searchResult: SearchResult
  isDrupalContent: boolean
}

function SearchResultsListItem({searchResult, isDrupalContent} : SearchResultProps) {

  const userAccount = useSelector((state:RootState) => state.userRdc.userDetail?.customer)
  const isRequestingAdd = useSelector((state:RootState) => state.userRdc.isRequestingAdd);
  const [productIdRequest, setProductIdRequest] = useState(0);

  return(
    <>
      {
        !isDrupalContent ?
          <ProductThumbView
            userAccount={userAccount}
            productItem={searchResult}
            isRequestingAdd={isRequestingAdd}
            productIdRequest={productIdRequest}
            setProductIdRequest={setProductIdRequest}
            key={searchResult.name}
          />

          :
          <div className="col-md-6">
            <div className="card py-3 mb-3 px-3">
              <strong>{ searchResult.title}</strong>
              {
                Object.values(searchResult.highlights).map((highlight: any) => {
                  return(
                    <div dangerouslySetInnerHTML={{__html: highlight}} key={highlight}/>
                  )
                })
              }
              <button className="btn btn-outline-primary mx-auto">
                {t('view_content')}
              </button>
            </div>
          </div>
      }
    </>
  )
}

export default SearchResultsListItem;
